<app-menu-top *ngIf="isAuthenticated$ | async"></app-menu-top>
<div class="app-body" [ngClass]="{ 'has-menu': isAuthenticated$ | async}">
  <router-outlet></router-outlet>
</div>
<app-notification-toast></app-notification-toast>

